<template lang="pug">
.fondoModal
	div
		div(style="max-width:200px;")
			.card
				.card-header
					|Listado de versiones
				table.table.table-condensed
					tbody
						tr(style="cursor:pointer" :class="(version.ID_version === actual.ID_version) ? 'bg-danger text-white' : ''" v-for="(version, i) in tarea.versiones" :key="version.ID_version" @click="selecciona(version)")
							th Version {{(i + 1)}}
							th
								span.fa.fa-check(v-if="version.ID_version === actual")
</template>


<script>
export default {
	name: 'listado-versiones',
	props: ['tarea', 'actual'],
	data: function () {
		return {

		}
	},

	methods: {
		selecciona (version) {
			let anterior = null
			for (let i = 0; i < this.tarea.versiones.length; i++) {
				if (this.tarea.versiones[i].ID_version === version.ID_version) {
					if (i > 0) {
						anterior = this.tarea.versiones[i - 1]
					}
				}
			}

			this.$emit('cambia-version', {
				actual: version,
				anterior: anterior
			})
		}
	}
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/produccion/listado-versiones.vue